<template lang="pug">
  .unsubscribe-button-component
    .unsubscribe-status(v-if="unsubscribed") {{ successLabel }}
    v-button.btn-primary(v-else="", :loading="form.busy", nativeType="button", @click="unsubscribe()")
      slot Unsubscribe
</template>

<script>
import axios from 'axios'

export default {
  name: 'unsubscribe-button',

  props: {
    email: {
      type: String,
      default: '',
    },
    successLabel: {
      type: String,
      default: 'Unsubscribed',
    },
  },

  data: () => ({
    form: {
      email: ''
    },
    unsubscribing: false,
    unsubscribed: false
  }),

  created() {
    this.form.email = this.email ?? this.$route.query.email
  },

  methods: {
    async unsubscribe () {
      try {
        this.unsubscribing = true
        await axios.post(`${window.addiesaas.url}/api/user/unsubscribe`, this.form)
        this.unsubscribed = true
      } finally {
        this.unsubscribing = false
      }
    }
  }
}
</script>
